/* ==========================================================================
   BioBird PDP — interactions for the long-form product page
   Vanilla JS, no dependencies. Safe to include from several sections.
   - variant sync (price, availability, media, URL, sticky bar, FBT)
   - quantity stepper + price-in-button
   - mobile swipe gallery (counter + dots) and desktop lightbox
   - sticky columns (shorter column waits while the taller one scrolls)
   - sticky add-to-cart bar
   - product-info tabs, ingredient pop-overs, coupon copy
   - frequently bought together (multi-item AJAX add)
   - recently viewed (localStorage) + recommendations (Shopify API) rails
   The main product form keeps its native submit so the existing cart app
   (GoKwik) and analytics continue to intercept "add to cart" exactly as before.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__bbpLoaded) return;
  window.__bbpLoaded = true;

  var RECENT_KEY = 'bbp:recent';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ------------------------------------------------------------ helpers -- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function readJSON(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function store(get, val) {
    try {
      if (get) return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      localStorage.setItem(RECENT_KEY, JSON.stringify(val));
    } catch (e) { return get ? [] : undefined; }
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || '₹{{amount}}';
    function delim(n, prec, th, dec) {
      th = th == null ? ',' : th; dec = dec == null ? '.' : dec;
      var num = (n / 100).toFixed(prec);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return whole + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = delim(cents, 0); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'"); break;
      default: v = delim(cents, 2);
    }
    var out = format.replace(/\{\{\s*\w+\s*\}\}/, v);
    var tmp = document.createElement('textarea'); tmp.innerHTML = out; // decode &amp; etc.
    return tmp.value;
  }

  function cartAdd(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data && (data.description || data.message) || 'Could not add to cart');
        return data;
      });
    });
  }
  function afterCartAdd(openCart) {
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('bb:cart:updated', { detail: c }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
    }).catch(function () {});
    if (openCart) {
      var link = $('.bb-cart') || $('a[href$="/cart"]');
      if (link) link.click(); else window.location.href = root + 'cart';
    }
  }

  /* ========================================================== MAIN PDP == */
  function initMain(sec) {
    if (!sec || sec.dataset.bbpBound) return;
    sec.dataset.bbpBound = '1';

    var moneyFormat = sec.getAttribute('data-money-format') || '₹{{amount}}';
    var product = readJSON($('[data-bbp-product]', sec)) || {};
    var variants = readJSON($('[data-bbp-variants]', sec)) || [];
    var form = $('[data-bbp-form]', sec);
    var idInput = form && $('[data-bbp-id]', form);
    var atc = $('[data-bbp-atc]', sec);
    var atcLabel = $('[data-bbp-atc-label]', sec);
    var atcPrice = $('[data-bbp-atc-price]', sec);
    var qtyInput = $('[data-bbp-qty-input]', sec);
    var atcText = atcLabel ? atcLabel.textContent : 'Add to cart';
    var current = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || variants[0];
    if (current && current.available && atcLabel) atcText = atcLabel.textContent;

    recordRecent(product);

    /* ---- quantity ---- */
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function refreshAtcPrice() {
      if (atcPrice && current) atcPrice.textContent = formatMoney(current.price * qty(), moneyFormat);
      if (qtyInput) {
        var minus = $('[data-bbp-step="-1"]', sec);
        if (minus) minus.disabled = qty() <= 1;
        var max = parseInt(qtyInput.getAttribute('max'), 10);
        var plus = $('[data-bbp-step="1"]', sec);
        if (plus) plus.disabled = !!max && qty() >= max;
      }
    }
    $$('[data-bbp-step]', sec).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var max = parseInt(qtyInput.getAttribute('max'), 10) || Infinity;
        var next = qty() + parseInt(btn.getAttribute('data-bbp-step'), 10);
        qtyInput.value = Math.min(max, Math.max(1, next));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var max = parseInt(qtyInput.getAttribute('max'), 10) || Infinity;
        qtyInput.value = Math.min(max, qty());
        refreshAtcPrice();
      });
      qtyInput.addEventListener('input', refreshAtcPrice);
    }
    refreshAtcPrice();

    /* ---- variants ---- */
    var radios = $$('[data-bbp-option]', sec);
    function selectedOptions() {
      var opts = [];
      radios.forEach(function (r) { if (r.checked) opts[parseInt(r.getAttribute('data-bbp-option'), 10)] = r.value; });
      return opts;
    }
    function markUnavailable() {
      var sel = selectedOptions();
      radios.forEach(function (r) {
        var i = parseInt(r.getAttribute('data-bbp-option'), 10);
        var test = sel.slice(); test[i] = r.value;
        var ok = variants.some(function (v) {
          return v.available && test.every(function (val, k) { return val == null || v.options[k] === val; });
        });
        var label = r.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !ok);
      });
    }
    function applyVariant(v) {
      current = v;
      var setText = function (sel, txt) { $$(sel, sec).forEach(function (el) { el.textContent = txt; }); };
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        if (atcPrice) atcPrice.hidden = true;
        syncSticky();
        return;
      }
      if (idInput) idInput.value = v.id;
      setText('[data-bbp-price]', formatMoney(v.price, moneyFormat));
      setText('[data-bbp-sticky-price]', formatMoney(v.price, moneyFormat));
      setText('[data-bbp-sticky-variant]', v.title);
      $$('[data-bbp-compare]', sec).forEach(function (el) {
        var on = v.compare_at_price && v.compare_at_price > v.price;
        el.hidden = !on;
        if (on) el.textContent = formatMoney(v.compare_at_price, moneyFormat);
      });
      $$('[data-bbp-save]', sec).forEach(function (el) {
        var on = v.compare_at_price && v.compare_at_price > v.price;
        el.hidden = !on;
        if (on) el.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF';
      });
      $$('[data-bbp-unit]', sec).forEach(function (el) {
        if (v.unit_price && v.unit_price_measurement) {
          var m = v.unit_price_measurement;
          el.textContent = formatMoney(v.unit_price, moneyFormat) + '/' + (m.reference_value !== 1 ? m.reference_value : '') + m.reference_unit;
          el.hidden = false;
        } else { el.hidden = true; }
      });
      if (atc) atc.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? atcText : 'Sold out';
      if (atcPrice) atcPrice.hidden = !v.available;
      selectedOptions().forEach(function (val, i) { setText('[data-bbp-opt-value="' + i + '"]', val); });
      refreshAtcPrice();
      markUnavailable();
      syncSticky();
      // FBT: keep "this item" in sync
      var fbtCur = $('[data-bbp-fbt-item][data-current]', sec);
      if (fbtCur) {
        fbtCur.setAttribute('data-variant-id', v.id);
        fbtCur.setAttribute('data-price', v.price);
        fbtCur.setAttribute('data-compare', v.compare_at_price || v.price);
        fbtCur.disabled = !v.available;
        if (!v.available) fbtCur.checked = false;
        setText('[data-bbp-fbt-current-price]', formatMoney(v.price, moneyFormat));
        sec.dispatchEvent(new CustomEvent('bbp:fbt:refresh'));
      }
      if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
      if (window.history && window.history.replaceState && !window.Shopify.designMode) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      sec.dispatchEvent(new CustomEvent('bbp:variant:change', { bubbles: true, detail: { variant: v } }));
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var sel = selectedOptions();
        var match = variants.filter(function (v) { return sel.every(function (val, i) { return v.options[i] === val; }); })[0];
        applyVariant(match || null);
      });
    });
    if (radios.length) markUnavailable();

    /* ---- gallery ---- */
    var gallery = $('[data-bbp-gallery]', sec);
    var track = gallery && $('[data-bbp-track]', gallery);
    var countEl = gallery && $('[data-bbp-count]', gallery);
    var dots = gallery ? $$('[data-bbp-dot]', gallery) : [];
    var items = track ? $$('.bbp-gallery__item', track) : [];
    var bigCount = items.filter(function (li) { return li.classList.contains('is-big'); }).length || 1;
    var mqMobile = window.matchMedia('(max-width: 989px)');

    function slideIndex() {
      if (!track || !items.length) return 0;
      var w = items[0].getBoundingClientRect().width || 1;
      return Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / w)));
    }
    function updateCounter() {
      var i = slideIndex();
      if (countEl) countEl.textContent = (i + 1) + ' / ' + items.length;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      // pause off-screen videos
      items.forEach(function (li, k) { var vid = $('video', li); if (vid && k !== i && !vid.paused) vid.pause(); });
    }
    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = null; updateCounter(); }); }, { passive: true });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var i = parseInt(d.getAttribute('data-bbp-dot'), 10);
          var w = items[0].getBoundingClientRect().width;
          track.scrollTo({ left: w * i, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('keydown', function (e) {
        if (!mqMobile.matches || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
        var w = items[0].getBoundingClientRect().width;
        track.scrollBy({ left: e.key === 'ArrowRight' ? w : -w, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }
    function relayout() {
      items = $$('.bbp-gallery__item', track);
      items.forEach(function (li, i) {
        var big = i < bigCount;
        li.classList.toggle('is-big', big);
        li.classList.toggle('is-thumb', !big);
        if (big) $$('img', li).forEach(function (img) { img.setAttribute('sizes', '(max-width: 749px) 100vw, (max-width: 1239px) 42vw, 520px'); });
      });
    }
    function showMedia(mediaId) {
      if (!track) return;
      var li = $('.bbp-gallery__item[data-media-id="' + mediaId + '"]', track);
      if (!li) return;
      if (li !== track.firstElementChild) { track.insertBefore(li, track.firstElementChild); relayout(); }
      if (mqMobile.matches) track.scrollTo({ left: 0, behavior: 'auto' });
      else {
        var r = gallery.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight) gallery.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
      updateCounter();
    }

    /* ---- lightbox ---- */
    var lb = $('[data-bbp-lightbox]', sec);
    var lbImg = lb && $('[data-bbp-lb-img]', lb);
    var lbIndex = 0;
    function lbSources() {
      return $$('[data-bbp-zoom] img', track).map(function (img) {
        var src = img.currentSrc || img.src;
        return { src: src.replace(/([?&])width=\d+/, '$1width=2000'), alt: img.alt };
      });
    }
    function lbShow(i) {
      var srcs = lbSources(); if (!srcs.length) return;
      lbIndex = (i + srcs.length) % srcs.length;
      lbImg.src = srcs[lbIndex].src; lbImg.alt = srcs[lbIndex].alt || '';
    }
    if (lb && lb.showModal) {
      sec.addEventListener('click', function (e) {
        var z = e.target.closest('[data-bbp-zoom]');
        if (!z || !sec.contains(z)) return;
        var zooms = $$('[data-bbp-zoom]', track);
        lbShow(zooms.indexOf(z));
        lb.showModal();
      });
      $$('[data-bbp-lb-step]', lb).forEach(function (b) {
        b.addEventListener('click', function () { lbShow(lbIndex + parseInt(b.getAttribute('data-bbp-lb-step'), 10)); });
      });
      $('[data-bbp-lb-close]', lb).addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
        if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      });
    }

    /* ---- sticky columns ---- */
    var cols = $$('[data-bbp-col]', sec);
    var mqDesk = window.matchMedia('(min-width: 990px)');
    var offset = parseInt(getComputedStyle(sec).getPropertyValue('--bbp-sticky-offset'), 10) || 16;
    var lastTop = -1;
    function headerBottom() {
      var nav = $('#bb-nav') || $('.bb-nav') || $('header');
      if (!nav) return 0;
      var cs = getComputedStyle(nav);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
      var r = nav.getBoundingClientRect();
      return r.top <= 1 && r.bottom > 0 ? Math.round(r.bottom) : 0;
    }
    function layoutCols() {
      var top = headerBottom();
      if (top !== lastTop) { sec.style.setProperty('--bbp-top', top + 'px'); lastTop = top; }
      cols.forEach(function (col) {
        if (!mqDesk.matches) { col.classList.remove('is-sticky'); col.style.top = ''; return; }
        var h = col.offsetHeight;
        var avail = window.innerHeight - top - offset;
        col.classList.add('is-sticky');
        col.style.top = (h <= avail ? top + offset : Math.round(window.innerHeight - h - 24)) + 'px';
      });
    }
    var colRaf = null;
    function queueCols() { if (!colRaf) colRaf = requestAnimationFrame(function () { colRaf = null; layoutCols(); }); }
    window.addEventListener('resize', queueCols, { passive: true });
    window.addEventListener('scroll', function () { if (headerBottom() !== lastTop) queueCols(); }, { passive: true });
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(queueCols); cols.forEach(function (c) { ro.observe(c); }); }
    $$('details', sec).forEach(function (d) { d.addEventListener('toggle', queueCols); });
    layoutCols();

    /* ---- sticky add to cart ---- */
    var sticky = $('[data-bbp-sticky]', sec);
    var stickyBtn = sticky && $('[data-bbp-sticky-btn]', sticky);
    var buyRow = $('[data-bbp-buy-row]', sec);
    function syncSticky() {
      if (!stickyBtn) return;
      var ok = current && current.available;
      stickyBtn.disabled = !ok;
      stickyBtn.textContent = current ? (ok ? atcText : 'Sold out') : 'Unavailable';
    }
    function setSticky(on) {
      if (!sticky) return;
      var visible = on && getComputedStyle(sticky).display !== 'none';
      sticky.classList.toggle('is-on', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = visible ? 0 : -1;
      document.body.classList.toggle('bbp-sticky-pad', visible);
      // BioBird mobile quick-nav dock: swap it out, or lift the bar above it
      var dock = $('.bb-mobile-dock');
      var dockOn = dock && getComputedStyle(dock).display !== 'none';
      var swap = sticky.getAttribute('data-dock') !== 'stack';
      document.body.classList.toggle('bbp-dock-swap', !!(visible && dockOn && swap));
      document.body.classList.toggle('bbp-dock-stack', !!(visible && dockOn && !swap));
      if (dockOn && !swap) {
        var r = dock.getBoundingClientRect();
        sticky.style.bottom = Math.max(0, Math.round(window.innerHeight - r.top) + 6) + 'px';
      } else { sticky.style.bottom = ''; }
    }
    if (sticky && buyRow && stickyBtn) {
      // scroll-based (not IntersectionObserver) so fast flings past the button are caught too
      var sRaf = null, lastOn = null;
      var checkSticky = function () {
        sRaf = null;
        var on = buyRow.getBoundingClientRect().bottom < 0;
        if (on !== lastOn) { lastOn = on; setSticky(on); }
      };
      window.addEventListener('scroll', function () { if (!sRaf) sRaf = requestAnimationFrame(checkSticky); }, { passive: true });
      window.addEventListener('resize', function () { lastOn = null; checkSticky(); }, { passive: true });
      checkSticky();
      stickyBtn.addEventListener('click', function () {
        if (!atc || atc.disabled || !form) return;
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
      syncSticky();
    }

    /* ---- form: guard double submits, keep native submit ---- */
    if (form && atc) {
      form.addEventListener('submit', function () {
        atc.classList.add('is-loading');
        setTimeout(function () { atc.classList.remove('is-loading'); }, 2500);
      });
    }

    /* ---- long description clamp ---- */
    $$('[data-bbp-clamp]', sec).forEach(function (box) {
      var btn = box.nextElementSibling && box.nextElementSibling.matches('[data-bbp-clamp-btn]') ? box.nextElementSibling : null;
      if (!btn) return;
      var measure = function () {
        var over = box.scrollHeight > box.clientHeight + 8 && !box.classList.contains('is-open');
        box.classList.toggle('is-clamped', over);
        btn.hidden = !over && !box.classList.contains('is-open');
      };
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        box.classList.toggle('is-clamped', !open);
        btn.textContent = open ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        queueCols();
      });
      var det = box.closest('details');
      if (det) det.addEventListener('toggle', measure);
      window.addEventListener('load', measure);
      measure();
    });

    /* ---- tabs ---- */
    $$('[data-bbp-tabs]', sec).forEach(function (wrap) {
      var tabs = $$('[role="tab"]', wrap);
      function activate(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) t.focus();
        queueCols();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') activate(tabs[(i + 1) % tabs.length], true);
          if (e.key === 'ArrowLeft') activate(tabs[(i - 1 + tabs.length) % tabs.length], true);
        });
      });
    });

    /* ---- ingredient pop-overs ---- */
    var chips = $$('[data-bbp-ing]', sec);
    function closeIngs(except) {
      chips.forEach(function (c) {
        if (c === except) return;
        c.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(c.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = c.getAttribute('aria-expanded') === 'true';
        closeIngs(c);
        c.setAttribute('aria-expanded', open ? 'false' : 'true');
        var p = document.getElementById(c.getAttribute('aria-controls'));
        if (!p) return;
        p.hidden = open;
        if (!open) {
          p.classList.remove('is-right');
          var r = p.getBoundingClientRect();
          if (r.right > window.innerWidth - 8) p.classList.add('is-right');
        }
      });
    });
    if (chips.length) {
      document.addEventListener('click', function (e) { if (!e.target.closest('.bbp-ing__pop')) closeIngs(); });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var openChip = chips.filter(function (c) { return c.getAttribute('aria-expanded') === 'true'; })[0];
        closeIngs(); if (openChip) openChip.focus();
      });
    }

    /* ---- coupon copy ---- */
    $$('[data-bbp-copy]', sec).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-bbp-copy');
        var done = function () {
          btn.classList.add('is-copied');
          var status = btn.closest('.bbp-offers') && $('[data-bbp-copy-status]', btn.closest('.bbp-offers'));
          if (status) status.textContent = 'Code ' + code + ' copied';
          clearTimeout(btn._t);
          btn._t = setTimeout(function () { btn.classList.remove('is-copied'); if (status) status.textContent = ''; }, 1800);
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(done, function () { legacyCopy(code); done(); });
        } else { legacyCopy(code); done(); }
      });
    });
    function legacyCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    }

    /* ---- FBT ---- */
    $$('[data-bbp-fbt]', sec).forEach(function (box) {
      var checks = $$('[data-bbp-fbt-item]', box);
      var btn = $('[data-bbp-fbt-add]', box);
      var totalEl = $('[data-bbp-fbt-total]', box);
      var compEl = $('[data-bbp-fbt-compare]', box);
      var err = $('[data-bbp-fbt-error]', box);
      function refresh() {
        var total = 0, comp = 0, n = 0;
        checks.forEach(function (c) {
          var li = c.closest('.bbp-fbt__item');
          if (li) li.classList.toggle('is-off', !c.checked);
          if (!c.checked || c.disabled) return;
          n++;
          total += parseInt(c.getAttribute('data-price'), 10) || 0;
          comp += parseInt(c.getAttribute('data-compare'), 10) || 0;
        });
        totalEl.textContent = formatMoney(total, moneyFormat);
        compEl.hidden = !(comp > total);
        if (comp > total) compEl.textContent = formatMoney(comp, moneyFormat);
        btn.disabled = n === 0;
      }
      checks.forEach(function (c) { c.addEventListener('change', refresh); });
      sec.addEventListener('bbp:fbt:refresh', refresh);
      btn.addEventListener('click', function () {
        var items = checks.filter(function (c) { return c.checked && !c.disabled; })
          .map(function (c) { return { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 }; });
        if (!items.length) return;
        var label = $('[data-bbp-fbt-label]', box);
        var orig = label.textContent;
        btn.disabled = true; label.textContent = 'Adding…'; err.hidden = true;
        cartAdd(items).then(function () {
          label.textContent = 'Added ✓';
          afterCartAdd(box.getAttribute('data-open-cart') === 'true');
          setTimeout(function () { label.textContent = orig; btn.disabled = false; }, 1800);
        }).catch(function (e) {
          label.textContent = orig; btn.disabled = false;
          err.textContent = e.message; err.hidden = false;
        });
      });
      refresh();
    });

    /* ---- smooth scroll to reviews ---- */
    $$('[data-bbp-scroll]', sec).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('bbp-reviews') || $('.jdgm-review-widget, .jdgm-widget, #judgeme_product_reviews');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ===================================================== RECENTLY VIEWED == */
  function recordRecent(p) {
    if (!p || !p.handle || window.Shopify && window.Shopify.designMode) return;
    var list = store(true).filter(function (x) { return x && x.handle !== p.handle; });
    list.unshift({
      handle: p.handle, title: p.title, url: p.url, image: p.image,
      price: p.price, compare_at_price: p.compare_at_price, available: p.available,
      single_variant: p.single_variant, variant_id: p.variant_id,
      rating: p.rating, rating_count: p.rating_count, t: Date.now()
    });
    store(false, list.slice(0, 12));
  }

  function initRecent(sec) {
    if (!sec || sec.dataset.bbpBound) return;
    sec.dataset.bbpBound = '1';
    var list = $('[data-bbp-recent-list]', sec);
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 6;
    var currentHandle = sec.getAttribute('data-current');
    var quick = sec.getAttribute('data-quick') === 'true';
    var fmt = sec.getAttribute('data-money-format');
    var items = store(true).filter(function (x) { return x && x.handle && x.handle !== currentHandle; }).slice(0, limit);
    if (!items.length) { sec.hidden = true; return; }
    list.innerHTML = items.map(function (p) {
      var img = p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="600" height="600">' : '';
      var rate = p.rating ? '<div class="bbp-card__rate"><span class="bbp-stars" style="--pct:' + (p.rating * 20).toFixed(1) + '%" aria-hidden="true"><span class="bbp-stars__base">★★★★★</span><span class="bbp-stars__fill">★★★★★</span></span><span>(' + esc(p.rating_count) + ')</span></div>' : '';
      var comp = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + esc(formatMoney(p.compare_at_price, fmt)) + '</s>' : '';
      var btn = '';
      if (quick) {
        if (!p.available) btn = '<button type="button" class="bbp-card__btn" disabled>Sold out</button>';
        else if (p.single_variant && p.variant_id) btn = '<button type="button" class="bbp-card__btn" data-bbp-quick="' + esc(p.variant_id) + '">Add to cart</button>';
        else btn = '<a class="bbp-card__btn" href="' + esc(p.url) + '">Choose</a>';
      }
      return '<li class="bbp-rail__item"><article class="bbp-card">' +
        '<a class="bbp-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="bbp-card__body">' + rate +
        '<h3 class="bbp-card__t"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
        '<div class="bbp-card__foot"><div class="bbp-card__p"><span>' + esc(formatMoney(p.price, fmt)) + '</span>' + comp + '</div>' + btn + '</div>' +
        '</div></article></li>';
    }).join('');
    sec.hidden = false;
    initRail($('[data-bbp-rail]', sec));
  }

  /* ===================================================== RECOMMENDATIONS == */
  function initRecs(sec) {
    if (!sec || sec.dataset.bbpBound) return;
    sec.dataset.bbpBound = '1';
    var url = sec.getAttribute('data-url');
    var target = $('[data-bbp-recs-target]', sec);
    if (!url || !target) return;
    if ($('.bbp-card', target)) { initRail($('[data-bbp-rail]', sec)); return; }
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var t = doc.querySelector('[data-bbp-recs-target]');
        if (!t || !t.querySelector('.bbp-card')) { sec.hidden = true; return; }
        target.innerHTML = t.innerHTML;
        initRail($('[data-bbp-rail]', sec));
      }).catch(function () { sec.hidden = true; });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(sec);
    } else load();
  }

  /* =============================================================== RAILS == */
  function initRail(rail) {
    if (!rail || rail.dataset.bbpBound) return;
    rail.dataset.bbpBound = '1';
    var track = $('[data-bbp-rail-track]', rail);
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      rail.classList.toggle('can-prev', track.scrollLeft > 2);
      rail.classList.toggle('can-next', track.scrollLeft < max);
    }
    $$('[data-bbp-rail-step]', rail).forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: parseInt(b.getAttribute('data-bbp-rail-step'), 10) * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ========================================================== QUICK ADD == */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bbp-quick]');
    if (!btn) return;
    e.preventDefault();
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    cartAdd([{ id: parseInt(btn.getAttribute('data-bbp-quick'), 10), quantity: 1 }]).then(function () {
      btn.textContent = 'Added ✓';
      afterCartAdd(false);
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
    }).catch(function () {
      btn.textContent = 'Try again'; btn.disabled = false;
    });
  });

  /* =============================================================== BOOT == */
  function boot(ctx) {
    $$('[data-bbp-main]', ctx).forEach(initMain);
    $$('[data-bbp-recent]', ctx).forEach(initRecent);
    $$('[data-bbp-recs]', ctx).forEach(initRecs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.BioBirdPDP = { formatMoney: formatMoney, boot: boot };
})();
